import React from "react";
import { statusMap } from "./constants";

export default function StatusRecord({ record }) {
  return (
    <div
      className="p-2 border rounded mb-2"
      style={{ background: "#fafafa" }}
    >
      <div>
        <strong>{statusMap[record.status] || record.status}</strong>
      </div>

      <div className="text-muted">
        {new Date(record.creationTime).toLocaleString()}
      </div>

      {record.createdBy && (
        <div className="text-primary">
          Изменил: <strong>{record.createdBy}</strong>
        </div>
      )}
    </div>
  );
}